/** Site logo in `public/images` (Petromin Express). Source: petromin.in brand asset. */
export const SITE_LOGO_SRC = "/images/petromin-express-logo.webp";

/** Shared accessible name for header, footer, login, and JSON-LD consumers. */
export const SITE_LOGO_ALT = "Petromin Express logo";

/** Absolute URL for JSON-LD / meta (falls back to petromin.com). */
export function siteLogoAbsoluteUrl(): string {
  const base = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "").trim();
  if (base) return `${base}${SITE_LOGO_SRC}`;
  return `https://petromin.com${SITE_LOGO_SRC}`;
}
